export default __webpack_public_path__ + "static/media/team.c0461cdb.jpg";